import React from "react";
import { useSelector } from "react-redux";
import Allergies from "../../service-steps/clinical-assessment/allergies";
import MedicalHistory from "../../service-steps/clinical-assessment/medical-history/medical-history";
import Adherence from "../../service-steps/clinical-assessment/adherence";

const ClinicalAssessment = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep;
    switch (subStep) {
      case 1:
        return <Allergies />;
      case 2:
        return <MedicalHistory />;
      case 3:
        return <Adherence />;
    }
  };
  return renderStep();
};

export default ClinicalAssessment;
